export default function ThePetition() {
    return (
        <>
            <h1>We have created a petition that you can sign to help spread the awareness</h1>
            <button className="btn-yellow">sign the petition</button>
        </>
    )
}
